import React from 'react';

import { useLocale } from '@hooks/useLocale';
import { EN_SHAREAHOLIC_ID, NL_SHAREAHOLIC_ID } from '@constants/config';
import { useAfterTimeout } from '@hooks/useAfterTimeout';
import Head from 'next/head';

const Share = () => {
  const locale = useLocale();

  const siteId = locale === 'nl-NL' ? NL_SHAREAHOLIC_ID : EN_SHAREAHOLIC_ID;
  const isVisible = useAfterTimeout(4000);

  return isVisible ? (
    <Head>
      <link
        rel="preload"
        href="https://cdn.shareaholic.net/assets/pub/shareaholic.js"
        as="script"
      />
      <meta name="shareaholic:site_id" content={siteId} />
      <script src="https://cdn.shareaholic.net/assets/pub/shareaholic.js" />
    </Head>
  ) : null;
};

export default Share;
